/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_CoordinatesInputs */

const cs_addr_field_coordinates = /** @type {(inputs: Addr_Field_CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souřadnice (GPS)`)
};

const en_addr_field_coordinates = /** @type {(inputs: Addr_Field_CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordinates (GPS)`)
};

/**
* | output |
* | --- |
* | "Coordinates (GPS)" |
*
* @param {Addr_Field_CoordinatesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_coordinates = /** @type {((inputs?: Addr_Field_CoordinatesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_CoordinatesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_coordinates(inputs)
	return cs_addr_field_coordinates(inputs)
});